import { ComponentsProps, ComponentsVariants, Theme } from "@mui/material";
import { ComponentsOverrides } from "@mui/material/styles/overrides";
import { tableRowClasses } from "@mui/material/TableRow";

type MuiTableRowOverrides = {
  defaultProps?: ComponentsProps['MuiTableRow'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTableRow'];
  variants?: ComponentsVariants['MuiTableRow'];
}

function getMuiTableRowOverride(): MuiTableRowOverrides {
  return {
    styleOverrides: {
      root: {
        transition: "background-color 150ms linear",
        ":hover": {
          backgroundColor: "var(--table-row-bg-hover)",
        },
        [`
        &.${tableRowClasses.head}, 
        &.${tableRowClasses.footer}
        `]: {
          ":hover": {
            backgroundColor: "initial"
          }
        }
      }
    }
  }
}

export default getMuiTableRowOverride;